'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._curry = exports.bsSizes = exports.bsStyles = exports.bsClass = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.prefix = prefix;
exports.getClassSet = getClassSet;
exports.addStyle = addStyle;

var _react = require('react');

var _styleMaps = require('./styleMaps');

var _styleMaps2 = _interopRequireDefault(_styleMaps);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function curry(fn) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var last = args[args.length - 1];
    if (typeof last === 'function') {
      return fn.apply(undefined, args);
    }
    return function (Component) {
      return fn.apply(undefined, args.concat([Component]));
    };
  };
}

function prefix() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var variant = arguments[1];

  (0, _invariant2.default)((props.bsClass || '').trim(), 'A `bsClass` prop is required for this component');
  return props.bsClass + (variant ? '-' + variant : '');
}

var bsClass = exports.bsClass = curry(function (defaultClass, Component) {
  var propTypes = Component.propTypes || (Component.propTypes = {});
  var defaultProps = Component.defaultProps || (Component.defaultProps = {});

  propTypes.bsClass = _react.PropTypes.string;
  defaultProps.bsClass = defaultClass;

  return Component;
});

var bsStyles = exports.bsStyles = curry(function (styles, defaultStyle, Component) {
  var comp = Component;
  var defStl = defaultStyle;
  if (typeof defStl !== 'string') {
    comp = defStl;
    defStl = undefined;
  }

  var existing = comp.STYLES || [];
  var propTypes = comp.propTypes || {};

  styles.forEach(function (style) {
    if (existing.indexOf(style) === -1) {
      existing.push(style);
    }
  });

  var propType = _react.PropTypes.oneOf(existing);

  // expose the values on the propType function for documentation
  comp.STYLES = propType._values = existing;

  comp.propTypes = _extends({}, propTypes, {
    bsStyle: propType
  });

  if (defStl !== undefined) {
    var defaultProps = comp.defaultProps || (comp.defaultProps = {});
    defaultProps.bsStyle = defStl;
  }

  return comp;
});

var bsSizes = exports.bsSizes = curry(function (sizes, defaultSize, Component) {
  var comp = Component;
  var dfSize = defaultSize;
  if (typeof dfSize !== 'string') {
    comp = dfSize;
    dfSize = undefined;
  }

  var existing = comp.SIZES || [];
  var propTypes = comp.propTypes || {};

  sizes.forEach(function (size) {
    if (existing.indexOf(size) === -1) {
      existing.push(size);
    }
  });

  var values = [];
  existing.forEach(function (size) {
    var mappedSize = _styleMaps2.default.SIZES[size];
    if (mappedSize && mappedSize !== size) {
      values.push(mappedSize);
    }

    values.push(size);
  });

  var propType = _react.PropTypes.oneOf(values);
  propType._values = values;

  // expose the values on the propType function for documentation
  comp.SIZES = existing;

  comp.propTypes = _extends({}, propTypes, {
    bsSize: propType
  });

  if (dfSize !== undefined) {
    if (!comp.defaultProps) {
      comp.defaultProps = {};
    }
    comp.defaultProps.bsSize = dfSize;
  }

  return comp;
});

function getClassSet(props) {
  var classes = _defineProperty({}, prefix(props), true);

  if (props.bsSize) {
    var bsSize = _styleMaps2.default.SIZES[props.bsSize];
    classes[prefix(props, bsSize)] = true;
  }

  if (props.bsStyle) {
    classes[prefix(props, props.bsStyle)] = true;
  }

  return classes;
}

/**
 * Add a style variant to a Component. Mutates the propTypes of the component
 * in order to validate the new variant.
 */
function addStyle(Component) {
  for (var _len2 = arguments.length, styleVariant = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    styleVariant[_key2 - 1] = arguments[_key2];
  }

  bsStyles(styleVariant, Component);
}

var _curry = exports._curry = curry;